import { useTranslation } from 'next-i18next';
import emitLocalEvent from 'hooks/emitLocalEvent';
import localEventNames from '@simplemining/dashboard/src/helpers/localEventNames/chips';

const maxValue = 99.99;
const valueStep = 0.01;

const handleEmit = (energyCost: string) => {
  emitLocalEvent({
    eventName: localEventNames.chipsPowerCost,
    data: {
      energyCost,
    },
  });
};

const PowerCostInput = (props: IPowerCostInput) => {
  const { value } = props;

  const { t } = useTranslation();

  const valueAsNumber = +value || 0;

  const handleChange = e => {
    const input: string = e.target.value
      .replace(/,/, '.')
      .replace(/[^0-9.]/, '');

    const hasMoreThanOnePoint = !!input.match(/(\..*){2,}/);
    const isToLong = input.length > String(maxValue).length;
    const isToBig = +input > maxValue;

    if (hasMoreThanOnePoint || isToLong || isToBig) {
      return;
    }

    handleEmit(input);
  };

  const handleBlur = e => {
    handleEmit(parseFloat(e.target.value || '0').toFixed(2));
  };

  const subtract = () => {
    if (valueAsNumber > 0) {
      const updatedValue = (valueAsNumber - valueStep).toFixed(2);

      handleEmit(updatedValue);
    }
  };

  const add = () => {
    if (valueAsNumber < maxValue) {
      const updatedValue = (valueAsNumber + valueStep).toFixed(2);

      handleEmit(updatedValue);
    }
  };

  return (
    <div className="power-cost">
      <label className="power-cost__label-energy" htmlFor="power-cost-input">
        {t('miningCalculator.power.title')}
      </label>
      <div className="power-cost__input-field">
        <button
          className="pricing-estimator__counter-subtract-btn"
          aria-label="subtract"
          onClick={subtract}
          disabled={valueAsNumber === 0}
        />
        <input
          type="text"
          inputMode="decimal"
          pattern="\d*"
          value={value}
          placeholder="0"
          onChange={handleChange}
          onBlur={handleBlur}
          id="power-cost-input"
          className="power-cost__input-energy"
        />
        <button
          className="pricing-estimator__counter-add-btn"
          aria-label="add"
          onClick={add}
          disabled={valueAsNumber === maxValue}
        />
        <span className="power-cost__input-energy-description">
          {t('miningCalculator.power.unit')}
        </span>
      </div>
    </div>
  );
};

export default PowerCostInput;
